import React, { useState } from "react";
import styled from "styled-components";

const FAQ = ({ faqData = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <Wrapper>
      {faqData.map((item, index) => (
        <FAQItem key={index} onClick={() => toggle(index)}>
          <QuestionRow>
            <Question>{item.question}</Question>
            <Icon active={activeIndex === index}>
              {activeIndex === index ? "−" : "+"}
            </Icon>
          </QuestionRow>

          <Answer active={activeIndex === index}>
            <p>{item.answer}</p>
          </Answer>
        </FAQItem>
      ))}
    </Wrapper>
  );
};

export default FAQ;

/* ================= STYLES ================= */

const Wrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const FAQItem = styled.div`
  background: #efefef;
  border-radius: 16px;
  margin-bottom: 15px;
  padding: 20px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.08);

  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

const QuestionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Question = styled.h5`
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
`;

const Icon = styled.div`
  font-size: 26px;
  color: #000000;
  transition: transform 0.3s ease;

  transform: ${({ active }) => (active ? "rotate(180deg)" : "rotate(0deg)")};
`;

const Answer = styled.div`
  max-height: ${({ active }) => (active ? "200px" : "0")};
  overflow: hidden;
  transition: max-height 0.4s ease;

  p {
    margin-top: 15px;
    font-size: 15px;
    color: #cfcfcf;
    line-height: 1.6;
  }
`;
